import React from "react";
import { useField, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import { formatNumeral } from "cleave-zen";

const MyNumberInputFormat = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    const { setFieldValue } = useFormikContext(); // Accede a Formik para actualizar valores

    const handleNumberChange = (event) => {
        const rawValue = event.target.value;
        const formattedValue = formatNumeral(rawValue); // Formatea el número

        setFieldValue(field.name, formattedValue); // Actualiza el valor en Formik
    };

    return (
        <TextField
            sx={{ width: "100%" }}
            variant="outlined"
            autoComplete="off"
            label={label}
            type="text" // Usa "text" en lugar de "number" para permitir el formateo
            {...field}
            {...props}
            value={field.value} // Asegura que Formik controle el valor
            onChange={handleNumberChange}
            error={meta.touched && Boolean(meta.error)}
            helperText={meta.touched && meta.error}
        />
    );
};

export default MyNumberInputFormat;